var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9998 18.3818L12.9998 19.3818V12.4598C12.9998 12.2238 13.0838 11.9948 13.2358 11.8148L19.8448 3.99976H4.15479L10.7638 11.8148C10.9158 11.9948 10.9998 12.2238 10.9998 12.4598V18.3818ZM14 21.9998C13.847 21.9998 13.694 21.9648 13.553 21.8948L9.55303 19.8948C9.21403 19.7248 9.00003 19.3788 9.00003 18.9998V12.8258L1.23603 3.64576C0.985028 3.34876 0.929028 2.93176 1.09303 2.57876C1.25703 2.22576 1.61103 1.99976 2.00003 1.99976H22C22.39 1.99976 22.743 2.22576 22.907 2.57876C23.071 2.93176 23.015 3.34876 22.764 3.64576L15 12.8258V20.9998C15 21.3468 14.82 21.6678 14.525 21.8508C14.365 21.9498 14.183 21.9998 14 21.9998Z",
    fill: "#29173B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.a7c68d1be3ac71f11e6e90b2a2f28d06.svg";
export { ForwardRef as ReactComponent };